import { Component } from '@angular/core';

import { ContainerComponent } from '../../../shared/components/container/container.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';

@Component({
  selector: '[facts]',
  imports: [ContainerComponent, PictureComponent],
  templateUrl: './facts.component.html',
  styleUrl: './facts.component.scss'
})
export class FactsComponent {

}
